module.exports = __webpack_public_path__ + "public/SiteIcons/commonModalCloseBtn.svg?9633e013";